import { useState } from 'react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import { Combobox } from '@headlessui/react'
import classNames from 'classnames'

const recordType = [
  { id: 1, type: 'All' },
  { id: 2, type: 'Listing' },
  { id: 3, type: 'Agent' },
  { id: 4, type: 'Office' }
]

interface RecordTypeProps {
  type?: string
}

export function RecordTypeFilter() {
  const [query, setQuery] = useState('')
  const [selectedRecordType, setSelectedRecordType] = useState()

  const filteredRecordType =
    query === ''
      ? recordType
      : recordType.filter((field) => {
          return field.type.toLowerCase().includes(query.toLowerCase())
        })

  return (
    <Combobox
      as="div"
      value={selectedRecordType}
      onChange={setSelectedRecordType}>
      {/* <Combobox.Label className="block text-sm font-medium text-gray-700 xs:py-4 md:py-0"></Combobox.Label> */}
      <div className="relative xs:mt-4 md:mt-3 lg:mt-1">
        <Combobox.Input
          placeholder="Sort by Record Type"
          className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400 sm:text-sm"
          onChange={(event) => setQuery(event.target.value)}
          displayValue={(field: RecordTypeProps) => field?.type || 'All'}
        />
        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </Combobox.Button>

        {filteredRecordType.length > 0 && (
          <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {filteredRecordType.map((field) => (
              <Combobox.Option
                key={field.id}
                value={field}
                className={({ active }) =>
                  classNames(
                    'relative cursor-default select-none py-2 pl-8 pr-4',
                    active ? 'bg-orange-400 text-white' : 'text-gray-900'
                  )
                }>
                {({ active, selected }) => (
                  <>
                    <span
                      className={classNames(
                        'block truncate',
                        selected && 'font-semibold'
                      )}>
                      {field.type}
                    </span>

                    {selected && (
                      <span
                        className={classNames(
                          'absolute inset-y-0 left-0 flex items-center pl-1.5',
                          active ? 'text-white' : 'text-orange-400'
                        )}>
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  )
}
